import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

const SUGGESTIONS = [
  'Analyze NIFTY 50 trend this week',
  'Compare TCS vs Infosys fundamentals',
  'Is RELIANCE fairly valued at current levels?',
  'Top midcap stocks with strong momentum',
  'HDFC Bank chart & key levels',
];

interface PromptBoxProps {
  onSubmit?: (prompt: string) => void;
  placeholder?: string;
}

const PromptBox: React.FC<PromptBoxProps> = ({
  onSubmit,
  placeholder = 'Ask anything about Indian stocks, indices or sectors…',
}) => {
  const [value, setValue] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const v = value.trim();
    if (!v) return;
    if (onSubmit) {
      onSubmit(v);
    } else {
      navigate(`/results?prompt=${encodeURIComponent(v)}`);
    }
    setValue('');
  };

  return (
    <div className="w-full max-w-3xl mx-auto">
      <form onSubmit={handleSubmit}>
        {/* Main input */}
        <div className="relative rounded-2xl border border-slate-200 bg-white overflow-hidden shadow-sm focus-within:border-navy-500 focus-within:shadow-md transition-all">
          <div className="flex items-start gap-3 p-4">
            <Sparkles className="w-4 h-4 text-navy-500 mt-1 shrink-0" />
            <textarea
              value={value}
              onChange={e => setValue(e.target.value)}
              placeholder={placeholder}
              rows={3}
              className="flex-1 bg-transparent text-slate-900 placeholder-slate-400 text-sm leading-relaxed resize-none outline-none"
              onKeyDown={e => {
                if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) handleSubmit(e as any);
              }}
            />
          </div>
          <div className="flex items-center justify-between px-4 pb-3">
            <span className="text-[11px] text-slate-400">⌘ Enter to send</span>
            <button
              type="submit"
              disabled={!value.trim()}
              className="flex items-center gap-1.5 px-4 py-2 rounded-xl bg-navy-500 hover:bg-navy-600 text-white text-sm font-semibold transition-all disabled:opacity-40 disabled:cursor-not-allowed"
            >
              Analyse <ArrowRight className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      </form>

      {/* Suggestion chips */}
      <div className="flex flex-wrap gap-2 mt-3">
        {SUGGESTIONS.map(s => (
          <button
            key={s}
            type="button"
            onClick={() => setValue(s)}
            className="text-[11px] px-3 py-1.5 rounded-full border border-slate-200 bg-white text-slate-500 hover:border-navy-300 hover:text-navy-600 hover:bg-navy-50 transition-colors"
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PromptBox;
